export class ObjectID {
  str: string = new Date().getTime().toString(16);

  constructor() {
  }
}
